function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.140625 5.64062L0.585938 6.10938C0.703125 6.22656 0.890625 6.22656 0.984375 6.10938L4.64062 2.47656V10.4688C4.64062 10.6328 4.75781 10.75 4.92188 10.75H5.57812C5.71875 10.75 5.85938 10.6328 5.85938 10.4688V2.47656L9.49219 6.10938C9.58594 6.22656 9.77344 6.22656 9.89062 6.10938L10.3359 5.64062C10.4531 5.54688 10.4531 5.35938 10.3359 5.24219L5.4375 0.34375C5.32031 0.226562 5.15625 0.226562 5.03906 0.34375L0.140625 5.24219C0.0234375 5.35938 0.0234375 5.54688 0.140625 5.64062Z",
  fill: "#12CC68"
});

var SvgIncreaseIcon = function SvgIncreaseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIncreaseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IncreaseIcon.6cfcc9ea.svg";
export { ForwardRef as ReactComponent };